/* eslint-disable import/prefer-default-export */
import { createRoutine } from 'redux-saga-routines';

export const fetchConversationByEntity = createRoutine('FETCH_CONVERSATION');
export const loadMoreConversationsByEntity = createRoutine(
  'LOAD_MORE_CONVERSATIONS'
);
export const clearConversations = createRoutine('CLEAR_CONVERSATIONS');
